import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { EntityNames } from "../../../../enums/EntityNames";

export const GlobalInvoicesSchema: ISchema = {
    displayName: "Invoices",
    resultsKey: "invoices",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true,
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.status,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'startDate',
            displayName: 'Start Date',
            type: PropertyTypes.dateOnly,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'endDate',
            displayName: 'End Date',
            type: PropertyTypes.dateOnly,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'download',
            displayName: '',
            type: PropertyTypes.download,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty
    ],

    primaryFilter: {
        PropertyName: "Reference",
        displayName: "Enter an invoice reference",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "AccountId",
            entityName: EntityNames.accounts,
            displayName: "Account",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid
        } as ISchemaFilter,
        {
            PropertyName: "Type",
            entityName: EntityNames.invoiceTypes,
            displayName: "Type",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int,
        } as ISchemaFilter,
    ],
    children: [],
};
